/**
 * Private Route
 *
 * Developed By : Travancore Analytics (2025)
 * Author: Akhil Soman
 * Created on: 28/02/2025
 * Project: Vitromed
 * Revision History:
 * SNo.   | Date        | Author        | Task                | Comments |
 * 1      28/02/2025    Akhil Soman      Creating new File
 */

import React from "react";
import { Navigate } from "react-router-dom";
import RoutePath from "../global/RoutePath.ts";

const PrivateRoute: React.FC<any> = ({ children }) => {
  const storedLoginStatus = localStorage.getItem("isLoggedIn");

  if (storedLoginStatus === "false") {
    return <Navigate to={RoutePath.home} />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
